import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-pr-md" }

import { computed, ref } from "vue";
import { AttributePositionSchema, AttributeSchema } from "@/types";
import { attributeLayoutSaveStore, attributesStore } from "@/hooks";
import {
  FlexBox,
  TextButton,
  Typography,
  IconButton,
  Separator,
  ExpansionItem,
} from "@/components/common";
import SaveAttribute from "./SaveAttribute.vue";


/**
 * Renders the list of project attributes and allows for editing them.
 */
const __default__ = {
  name: "AttributeEditor",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const createOpen = ref(false);

const attributes = computed(() => attributesStore.attributes);

const layoutStore = computed(() =>
  attributeLayoutSaveStore(attributesStore.selectedLayoutId)
);

/**
 * @return Whether this attribute is in the current layout.
 */
function isAttributeInLayout(attribute: AttributeSchema): boolean {
  return !!layoutStore.value.editedLayout.positions.find(
    ({ key }: AttributePositionSchema) => key === attribute.key
  );
}

/**
 * Adds an attribute to the current layout.
 * @param attribute - The attribute to add.
 */
function handleAddToLayout(attribute: AttributeSchema): void {
  layoutStore.value.addAttribute(attribute.key);
}

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FlexBox), {
      "full-width": "",
      wrap: "",
      justify: "between",
      align: "center",
      t: "1"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Typography), {
          variant: "subtitle",
          value: createOpen.value ? 'Attribute' : 'Attributes'
        }, null, 8, ["value"]),
        _createVNode(_component_q_space),
        (!createOpen.value)
          ? (_openBlock(), _createBlock(_unref(TextButton), {
              key: 0,
              text: "",
              label: "Create",
              icon: "add",
              "data-cy": "button-add-attribute",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (createOpen.value = true))
            }))
          : (_openBlock(), _createBlock(_unref(TextButton), {
              key: 1,
              text: "",
              label: "Cancel",
              icon: "cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (createOpen.value = false))
            }))
      ]),
      _: 1
    }),
    (createOpen.value)
      ? (_openBlock(), _createBlock(SaveAttribute, {
          key: 0,
          onSave: _cache[2] || (_cache[2] = ($event: any) => (createOpen.value = false))
        }))
      : _createCommentVNode("", true),
    (createOpen.value)
      ? (_openBlock(), _createBlock(_unref(Separator), { key: 1 }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attribute) => {
      return (_openBlock(), _createBlock(_unref(ExpansionItem), {
        key: attribute.key,
        label: attribute.label
      }, {
        icon: _withCtx(() => [
          _createElementVNode("span", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_unref(IconButton), {
              class: "ml-auto",
              icon: "add",
              tooltip: "Add to layout",
              disabled: isAttributeInLayout(attribute),
              "data-cy": "button-add-attribute-to-layout",
              onClick: ($event: any) => (handleAddToLayout(attribute))
            }, null, 8, ["disabled", "onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(SaveAttribute, { attribute: attribute }, null, 8, ["attribute"]),
          _createVNode(_unref(Separator), { class: "faded" })
        ]),
        _: 2
      }, 1032, ["label"]))
    }), 128)),
    (attributes.value.length === 0)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 2,
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Typography), {
              variant: "caption",
              value: "You have not yet created any custom attributes."
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})